<template>
  <section class="py-4">
    <b-container>
      <b-breadcrumb>
        <b-breadcrumb-item @click="$router.push({ name: 'salesforce-admin-panel' })">
          <b-icon aria-hidden="true" icon="people-fill" scale="1.25" shift-v="1.25"></b-icon>
          Users
        </b-breadcrumb-item>
        <b-breadcrumb-item active> {{ userForm.name }}</b-breadcrumb-item>
      </b-breadcrumb>
      <b-card no-body>
        <b-tabs
          id="userTabs"
          v-model="tabIndex"
          active-nav-item-class="font-weight-bold text-primary"
          card
          lazy
        >
          <b-tab
            :title-item-class="linkClass(0)"
            title="Role & Permissions"
            @click="setQueryParam(tabMap[0])"
          >
            <loading v-if="loading"></loading>
            <edit-user v-if="!loading" @userUpdated="userUpdated" />
          </b-tab>
          <b-tab
            :title-item-class="linkClass(1)"
            title="Impersonation"
            @click="setQueryParam(tabMap[1])"
          >
            <manage-user-impersonation />
          </b-tab>
          <b-tab :title-item-class="linkClass(2)" title="Surveys" @click="setQueryParam(tabMap[2])">
            <user-surveys :surveys="surveys" />
          </b-tab>
        </b-tabs>
      </b-card>
    </b-container>
  </section>
</template>

<script>
  import { mapMutations, mapState } from 'vuex';
  import UserSurveys from '../surveys/UserSurveys';
  import EditUser from '../users/EditUser';
  import ManageUserImpersonation from './ManageUserImpersonation.vue';

  export default {
    name: 'ShowUserProfile',
    components: { EditUser, UserSurveys, ManageUserImpersonation },
    data() {
      return {
        loading: false,
        surveys: [],
        tabIndex: 0,
        tabMap: {
          0: 'RoleAndPermissions',
          1: 'Impersonation',
          2: 'Surveys',
        },
      };
    },
    computed: {
      ...mapState({
        userForm: state => state.salesforceUserForm.userForm,
      }),
    },
    created() {
      this.loading = true;
      this.getSurveys();
      const isEmpty = Object.values(this.userForm).every(x => x === null || x === '');
      if (isEmpty) {
        this.getUserDetails();
      } else {
        this.loading = false;
      }
    },
    methods: {
      ...mapMutations({
        setForm: 'updateUserForm',
      }),
      setQueryParam(currentTab) {
        this.$router.push({ query: { tab: currentTab } });
      },
      linkClass(idx) {
        if (this.tabIndex === idx) {
          return ['text-success'];
        } else {
          return ['text-danger'];
        }
      },
      userUpdated() {
        this.$bvToast.toast('User Updated', {
          title: 'Success',
          autoHideDelay: 5000,
          appendToast: true,
          variant: 'success',
        });
      },
      getUserDetails() {
        let userId = this.$route.params['userId'];
        axios
          .get(`/api/salesforce/users/${userId}`)
          .then(res => {
            this.setForm(res.data.data);
            this.tabIndex = Number(
              Object.keys(this.tabMap).find(key => this.tabMap[key] === this.$route.query.tab),
            );
            this.loading = false;
          })
          .catch(err => {
            console.error(err);
            this.$bvToast.toast('Error getting user`s details', {
              title: 'Error',
              variant: 'danger',
              solid: true,
            });
          });
      },
      async getSurveys() {
        await axios
          .get(`/api/salesforce/surveys`)
          .then(results => {
            this.surveys = results.data.items;
            this.surveys.forEach(survey => {
              delete survey['status'];
            });
          })
          .catch(error => {
            console.error(error);
            this.$bvToast.toast('Error getting user`s surveys', {
              title: 'Error',
              variant: 'danger',
              solid: true,
            });
          });
      },
    },
  };
</script>

<style>
  #userTabs .nav-link {
    font-weight: 400;
    font-size: 14px;
    color: #1c1b1e;
  }
</style>
